<form class="container-form" [formGroup]="pcForm">
    <div class="card py-3">
        <span class="title-card">กรอกข้อมูล E-coupon</span>
        <div class="row">
          <div class="col-sm-12">
            <label for="coupon" class="col-form-label"
              >รายการ E-coupon <span class="text-danger">*</span></label
            >
          </div>
          <div class="col-sm-12">
            <select
              class="form-select"
              id="coupon"
              formControlName="coupon"
              (change)="changeCoupon($event)"
            >
              <option value="" disabled selected>เลือกรายการ E-coupon</option>
              <option *ngFor="let coupon of coupons" [value]="coupon.id">
                {{ coupon.name }}
              </option>
              <!-- Add options here -->
            </select>
          </div>
        </div>
        <div
          *ngIf="f['couponBatchCode'].value && f['coupon'].value != ''"
          class="row"
        >
          <div class="col-sm-12">
            <label for="batchCode" class="col-form-label"
              >Batch Code<span class="text-danger">*</span></label
            >
          </div>
          <div class="col-sm-12">
            <input
              type="text"
              class="form-control"
              id="batchCode"
              formControlName="batchCode"
              placeholder="กรอก Batch Code"
            />
            <div *ngIf="f['batchCode'].touched && f['batchCode'].invalid" class="text-danger">
            <small *ngIf="f['batchCode'].errors?.['required']">กรุณากรอก Batch Code</small>
            </div>
          </div>
        </div>
        <div *ngIf="f['couponBatchCode'].value" class="row">
          <div class="col-sm-12">
            <label class="col-form-label"
              >อัปโหลดสลิป<span class="text-danger">*</span></label
            >
          </div>
          <div class="col-sm-12">
          <app-drop-zone-image formControlName="imageUrl" (image)="onImageSelected($event)"></app-drop-zone-image>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label for="assistantPc" class="col-form-label"
              >Assistance PC<span class="text-danger">*</span></label
            >
          </div>
          <div class="col-sm-12">
            <input
              type="text"
              class="form-control"
              id="assistantPc"
              formControlName="assistantPc"
              placeholder="กรอก Assistance PC"
            />
          </div>
        </div>
      </div>
    </form>